import * as track from 'lib/gaTracking/bookingListPageEvents';
import * as crossPageTrack from 'lib/gaTracking/crossPageEvents';
import { CardWrapper, CardImage, InfoWrapper, Heading, SubHeading, StayInfo, Hr, ItemLinks } from '../Components';
import { useBookingList } from 'pages/BookingListPage/BookingListProvider';
import { SelfServiceAPI } from 'types';

interface PastBookingCardProps {
  booking: SelfServiceAPI.PastBooking;
  [key: string]: any;
}

const PastBookingCard = ({ booking, index, ...rest }: PastBookingCardProps) => {
  const { sendViewBookingEvent } = useBookingList();

  const {
    id,
    links,
    mediumImage,
    reservation: { property },
  } = booking;

  const trackViewBookingEvent = () => sendViewBookingEvent(id);

  const detailsLink = {
    label: 'View details',
    url: links.manage,
    onClick: () => {
      track.viewDetailsLink(booking);
      trackViewBookingEvent();
    },
  };

  const rebookLink = {
    label: 'Book again',
    url: links.rebook,
    external: true,
    onClick: crossPageTrack.bookAgainLink,
    target: '_blank',
  };

  const itemLinks = [detailsLink, rebookLink];

  return (
    <CardWrapper>
      <CardImage {...mediumImage} link={detailsLink} onClick={trackViewBookingEvent} />
      <InfoWrapper bookingId={booking.id} {...rest}>
        <Heading>{property.name}</Heading>
        <SubHeading>{property.address.suburb}</SubHeading>

        <StayInfo booking={booking} />
      </InfoWrapper>

      <Hr />

      <ItemLinks links={itemLinks} />
    </CardWrapper>
  );
};

PastBookingCard.displayName = 'PastBookingCard';

export { PastBookingCard };
